<template>
  <q-section v-bind="$attrs">
    <q-section f="12 #fff 400" wh="22.5" pl="11" pt="20" class="flex justify-center items-center">{{ days }}</q-section>
    <q-section f="12 #fff 400" wh="22.5" pl="47" pt="20" class="flex justify-center items-center">{{ hours }}</q-section>
    <q-section f="12 #fff 400" wh="22.5" pl="83" pt="20" class="flex justify-center items-center">{{ minutes }}</q-section>
    <q-section f="12 #fff 400" wh="22.5" pl="119" pt="20" class="flex justify-center items-center">{{ seconds }}</q-section>
  </q-section>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useTimer } from '@/ui-runtime/core/composable/use-timer'
const route = useRoute()
const { days, hours, minutes, seconds } = useTimer((route?.meta as any)?.endTime || 0)

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
})
</script>

<style scoped lang="scss"></style>
